module.exports = __webpack_public_path__ + "static/media/notifications-activer-cercle.65bf51ff.png";